
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.75 23H26V5.75A1.752 1.752 0 0 0 24.25 4H7.75A1.752 1.752 0 0 0 6 5.75V23H4.25a.25.25 0 0 0-.25.25v4.5a.25.25 0 0 0 .25.25h23.5a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25Zm-11 0v-8h7.75v8h-7.75Zm7.5-17.5a.25.25 0 0 1 .25.25v7.75h-7.75v-8h7.5Zm-16.5 0h7.5v8H7.5V5.75a.25.25 0 0 1 .25-.25ZM7.5 15h7.75v8H7.5v-8Z"}})])
          )
        }
      }
    